export interface IProfile {
  profile: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

/* La API manda la description de los perfiles vacía, así que las etiquetas
   que ve el sudo viven aquí. Un perfil nuevo sin etiqueta se muestra con su
   código (ver Profile.labelOf). */
export const PROFILE_LABELS: Record<string, string> = {
  sudo: 'Superadministrador',
  admin: 'Administrador',
  user: 'Cliente'
};

/* Ícono Material y tono semántico por perfil. El tono nunca es lo único que
   distingue al perfil: el badge siempre lleva ícono y texto. */
export const PROFILE_ICONS: Record<string, string> = {
  sudo: 'admin_panel_settings',
  admin: 'manage_accounts',
  user: 'person'
};

export const PROFILE_TONES: Record<string, string> = {
  sudo: 'brand',
  admin: 'info',
  user: 'neutral'
};

/* Orden de las opciones: de mayor a menor alcance; los demás al final. */
export const PROFILE_ORDER: string[] = ['sudo', 'admin', 'user'];

export class Profile {
  profile: string;
  description: string;
  createdAt: string;
  updatedAt: string;

  constructor(data: IProfile) {
    this.profile = data.profile;
    this.description = data.description;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  static labelOf(code: string): string {
    return PROFILE_LABELS[code] ?? code;
  }

  static iconOf(code: string): string {
    return PROFILE_ICONS[code] ?? 'person';
  }

  static toneOf(code: string): string {
    return PROFILE_TONES[code] ?? 'neutral';
  }

  static rankOf(code: string): number {
    const index: number = PROFILE_ORDER.indexOf(code);

    return index === -1
      ? PROFILE_ORDER.length
      : index;
  }

  get label(): string {
    return Profile.labelOf(this.profile);
  }
}
